module.exports = __webpack_public_path__ + "static/media/store.dc5e90c5.svg";